import { useEffect, useMemo, useState } from "react";
import TitlePage from "../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import { ConsultaTotvsEmpresaIndividual } from "../../../../backend/ConsultaTotvsEmpresa";
import ResponsiveDataTable from "../../../components/DataTable";
import LoadingSpinner from "../../../components/LoadinSpinner";

import SolicitacaoPagamento from "../../../../lib/json/consultas/SolicitacaoPagamento.json"
import SelectEmpresa from "../../../components/Select/Empresa";
import { ErroMsg, formatarComoMoeda, formatDateColumn, RetornaUsuarioLogado, SucessoMsg } from "../../../contents/VariaveisGlobais";
import { useNavigate } from "react-router-dom";
import { usePopUp } from "../../../components/BootBox";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import { useSessionStorageState } from "../../../../hooks/useSessionStorageState";
import { handleValorTotal } from "../../../components/GridCell/Preco";
import { handleFornecedorSPColumn, handleNumeroSPColumn, handleStatusSPColumn } from "../../../components/GridCell/SolicitacaoPagamento";
import { format, startOfMonth } from "date-fns";
import InputGeral from "../../../components/InputGeral/Index";
import SelectFornecedor from "../../../components/Select/Fornecedor";
import SelectFixo from "../../../components/SelectFixo";
import ExportarExcel from "../../../components/ExportarExcel";

function ListaSolicitacaoPagamento(){
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    const usuarioLogado = RetornaUsuarioLogado()
    const usuarioProtheus = usuarioLogado.usuarioProtheus
    const currentDate = new Date()
    const firstDayOfMonthDate = startOfMonth(currentDate);
    // define a exibição do Loading
    var tabelasDefault  = SolicitacaoPagamento.tabelas;
    
    const navigate = useNavigate();

    const options = [
        {
            value: '0',
            text: "Todos",
            filtroSQL: "( 1 = 1 )"
        },
        {
            value: '1',
            text: "Em Aberto",
            filtroSQL: "( PS9_STATUS IN ('C','A','R','X') )"
        },
        {
            value: '2',
            text: "Título Gerado",
            filtroSQL: "( PS9_STATUS = 'T' AND E2_SALDO = E2_VALOR AND E2_VALOR > 0 )"
        },
        {
            value: '3',
            text: "Título Pago",
            filtroSQL: "( PS9_STATUS = 'T' AND E2_SALDO = 0 AND E2_VALOR > 0 )"
        },
        {
            value: '4',
            text: "Título Parcial",
            filtroSQL: "( PS9_STATUS = 'T' AND E2_SALDO != E2_VALOR AND E2_VALOR > 0 )"
        }
    ]
    
    const [carregar, setCarregar] = useState(false);
    const [data, setData]   = useState([]);
    const [empresa, setEmpresa] = useSessionStorageState("solicitacaoPagamentoEmpresa", {value: "",text: "", });
    const [campoFornecedor, setCampoFornecedor] = useSessionStorageState("solicitacaoPagamentoFornecedor", null);
    const [solicitacao, setSolicitacao] = useSessionStorageState("solicitacaoPagamentoSolicitacao", '');
    const [dateDe, setDateDe] = useSessionStorageState("solicitacaoPagamentoDataDe", format(firstDayOfMonthDate, 'yyyy-MM-dd'));
    const [dateAte, setDateAte] = useSessionStorageState("solicitacaoPagamentoDataAte", format(currentDate, 'yyyy-MM-dd'));
    const [campoStatus, setCampoStatus] = useSessionStorageState("solicitacaoPagamentoStatus", options[1]);
    
    // Colunas do Excel
    const excelColumns = [
        {
            Header: 'Filial',
            accessor: "PS9_FILIAL",
        },
        {
            Header: 'Solicitação Pagamento',
            accessor: "PS9_ID",
        },
        {
            Header: 'Fornecedor',
            accessor: "PS9_FORNEC",
        },
        {
            Header: 'Loja Fornecedor',
            accessor: "PS9_LOJA",
        },
        {
            Header: 'Nome Fornecedor',
            accessor: "A2_NOME",
        },
        {
            Header: 'Centro Custo',
            accessor: "PS9_CC",
        },
        {
            Header: 'Descrição Centro Custo',
            accessor: "CTT_DESC01",
        },
        {
            Header: 'Data Emissão',
            accessor: "PS9_EMISSA",
            Cell: formatDateColumn
        },
        {
            Header: 'Data Vencimento',
            accessor: "PS9_VENCTO",
            Cell: formatDateColumn
        },
        {
            Header: 'Numero Título',
            accessor: "PS9_NUMTIT",
        },
        {
            Header: 'Valor',
            accessor: "PS9_VALOR",
            Cell: (item) => { return formatarComoMoeda(item.value)}
        },
        {
            Header: 'Status',
            accessor: 'PS9_STATUS',
            Cell: handleStatusSPColumn
        },        
        {
            Header: 'Data Aprovação',
            accessor: "PS9_DTAPRV",
            Cell: formatDateColumn
        }
    ]
    // Colunas do grid
    const columns = [
        {
            Header: 'SP',
            accessor: "PS9_FILIAL",
            Cell: (item) => handleNumeroSPColumn(item, DisparaBootBox, FechaBootBox, navigate),
        },        
        {
            Header: 'Fornecedor',
            accessor: "PS9_FORNEC",
            Cell: handleFornecedorSPColumn 
        },        
        {
            Header: 'Emissão',
            accessor: 'PS9_EMISSA',
            Cell: formatDateColumn
        },
        {
            Header: 'Vencimento',
            accessor: 'PS9_VENCTO',
            Cell: formatDateColumn
        },
        {
            Header: 'Valor',
            accessor: 'PS9_VALOR',
            Cell: handleValorTotal
        },
        {
            Header: 'Status',
            accessor: 'PS9_STATUS',
            Cell: (item) => handleStatusSPColumn(item, DisparaBootBox, FechaBootBox, navigate),
        }
    ];

    const retornaConsultaDefault = () => {
        var consultaDefault = SolicitacaoPagamento.consulta;

        if (usuarioLogado?.solicitacaoPagamento !== false){
            consultaDefault += "AND PS9_DESCR = '" + usuarioProtheus.value + "' ";
			consultaDefault += "AND PS9_DESCR != '' ";
        }
        
        if(solicitacao) {
            consultaDefault += "AND PS9_ID = '"+solicitacao+"' ";
        }
        if(dateDe) {
            consultaDefault += "AND PS9_EMISSA >= '"+dateDe.replaceAll('-','')+"' ";
        }
        if(dateAte) {
            consultaDefault += "AND PS9_EMISSA <= '"+dateAte.replaceAll('-','')+"' ";
        }
        if(campoFornecedor?.value) {
            consultaDefault += "AND PS9_FORNEC + PS9_LOJA = '"+campoFornecedor.value+"' ";
        }
        if(campoStatus) {
            consultaDefault += "AND "+campoStatus.filtroSQL+" ";
        }
        
        consultaDefault += "ORDER BY PS9_FILIAL ASC, PS9_ID DESC";
        //Implementar Regra Filtragem Empresa x CC

        return consultaDefault
    }

    // Processa consulta do grid
    const listaSolicitacaoPagamento = async () => {
        var consultaDefault = retornaConsultaDefault();
        let empresaFilial = empresa.value ? empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) : ''

        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, tabelasDefault, empresaFilial );
        
        if (retConsulta){
            setData(retConsulta.data);
        } 

        setCarregar(false);
    }

    useEffect( () => {
        listaSolicitacaoPagamento()
    },[])

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.original.PS9_ID}/${row.original.EMPRESA}${row.original.PS9_FILIAL}`)
    }
    
    const handleVisualizar = (row) =>{
        navigate(`./Visualizar/${row.original.PS9_ID}/${row.original.EMPRESA}${row.original.PS9_FILIAL}`)
    }
    
     const handleExcluir = async (row) => {
        const idRow = row.original.EMPRESA + '' + row.original.PS9_FILIAL + '|' + row.original.PS9_ID;
        const Mensagem = `Tem certeza que deseja excluir a Solicitação de Pagamento ${row.original.PS9_ID + ' - da Filial: ' + row.original.PS9_FILIAL}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };

    const handleExcluirConfirm = async(row) => {
        const empresaFilial = row.split('|')[0]
        const cJSONSalvar = { PS9_ID: row.split('|')[1] }

        FechaBootBox()
        try {
            setCarregar(true);

            const oRetorno = await ConsumoTOTVS_POST('EXCLUIRSOLICITACAOPAGAMENTO', cJSONSalvar, empresaFilial)
            
            if (oRetorno.error === '00'){
                SucessoMsg(oRetorno.description)
            }else{
                ErroMsg(oRetorno.description)
                return false;
            }
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
            listaSolicitacaoPagamento();
        }
    };

    const excelHeaders = useMemo(() => {
        return excelColumns.map(col => col.Header);
    }, [excelColumns]);

    const excelRows = useMemo(() => {
        return data.map(item =>
            excelColumns.map(col => {
                const value = item[col.accessor];

                if (col.Cell) {
                    return col.Cell({ value, row: { original: item } });
                }
                return value ?? ""; // valor padrão se undefined/null
            })
        );
    }, [data, excelColumns]);

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Solicitação de Pagamento" exibirIncluir={usuarioProtheus && usuarioProtheus.value.trim()}/>
                </Col>
                <Col md='4'>
                    <SelectEmpresa
                        campoEmpresa={empresa}
                        onChangeEmpresa={setEmpresa}
                    />
                </Col>
                <Col md="8" xs="12">
                    <SelectFornecedor
                        campoFornecedor={campoFornecedor}
                        changeFornecedor={setCampoFornecedor}
                        empresaLogada={empresa.value}
                    />
                </Col>
            </Row>
            <Row>
                <Col md="2" xs="12">
                    <InputGeral 
                        label="Sol. Pagto"
                        tipo='text'
                        max="6"
                        value={solicitacao}  // Define o valor do campo com base no estado
                        onChange={(e) => setSolicitacao(e.target.value)}
                    />
                </Col>
                <Col md="3" xs="12">
                    <InputGeral
                        label="Emissão de"
                        tipo='date'
                        value={dateDe}
                        onChange={(e) => setDateDe(e.target.value)}
                    />
                </Col>
                <Col md="3" xs="12">
                    <InputGeral
                        label="Emissão até"
                        tipo='date'
                        value={dateAte}
                        onChange={(e) => setDateAte(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <SelectFixo 
                        options={options} 
                        value={campoStatus} 
                        selectedOptionValue={campoStatus}
                        isLabel={true} 
                        label="Status" 
                        onChange={(e) => setCampoStatus(e)}
                    />
                </Col>                
            </Row>
            <Row className="d-flex justify-content-end">
                <Col md="3" xs="12">
                    <Button 
                        variant="outline-primary" 
                        type="submit" 
                        onClick={listaSolicitacaoPagamento}
                        className="w-100"
                    >
                        Buscar
                    </Button>
                </Col>
                <Col md="3" xs="12">
                    <ExportarExcel 
                        nomeArquivo="Solicitacao_Compra"
                        headers={excelHeaders}
                        rows={excelRows}
                    />
                </Col>
            </Row>
            
            { usuarioProtheus && usuarioProtheus.value.trim() &&
                <Row>
                    <Col md="12" xs="12">
                        <ResponsiveDataTable 
                            columns={columns} 
                            data={data} 
                            buttons={[
                                {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                                {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote" , regraExclude: "(row.original.PS9_STATUS === 'T')"}, 
                                {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", style: "danger" , regraExclude: "(row.original.PS9_STATUS === 'T')"}
                            ]}
                        />
                    </Col>
                </Row>
            }
        </>
    );
}

export default ListaSolicitacaoPagamento;